import React, {useState} from 'react';
import {useDispatch} from 'react-redux';
import {Confirm, Icon} from 'semantic-ui-react';
import {Actions} from '../../../common/actions';
import {prepareSelected} from '../../utils/commonUtils';

const {
  removeDatesPriorization,
} = Actions;

const RemoveDate = ({type, data}) => {
  const dispatch = useDispatch();
  const [openModal, setOpenModal] = useState(false);
  const handleRemoveDate = () => {
    const vehicleArray = prepareSelected(data);
    const reqData = {
      'type': type?.key,
      'vehicleArray': vehicleArray,
    };
    dispatch(removeDatesPriorization(type?.value, {'data': reqData}));
    setOpenModal(false);
  };
  return (
    <>
      <Icon
        title={`REMOVER FECHA DE ${type?.value}`}
        name='minus circle'
        size='large'
        className='pointer'
        color='red'
        onClick={() => setOpenModal(true)}
      />
      <Confirm
        size='tiny'
        open={openModal}
        header='¿SEGURO QUE DESEA CONTINUAR?'
        content={`¿DESEA ELIMINAR LAS FECHAS DE ${type?.value} DE LOS VEHÍCULOS SELECCIONADOS?`}
        onCancel={() => setOpenModal(false)}
        onConfirm={handleRemoveDate}
        cancelButton='Cancelar'
        confirmButton="Confirmar"
      />
    </>
  );
};

export default RemoveDate;
